import {
  SiteNetworkDevice,
  CreateSiteNetworkDeviceRequest,
  UpdateSiteNetworkDeviceRequest,
} from '../models/SiteNetworkDevice';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';
import {
  ApiItemResponse,
  ApiListResponse,
  ApiOkResponse,
  ensureOk,
  unwrapItem,
  unwrapList,
} from './api/response';

export class SiteNetworkDeviceService {
  static async list(projectId: number): Promise<SiteNetworkDevice[]> {
    const response = await apiClient.get<ApiListResponse<SiteNetworkDevice>>(
      API_ENDPOINTS.SITE_MANAGEMENT.NETWORK_DEVICES.LIST(projectId),
    );
    return unwrapList(response, '네트워크 장비 목록 조회 실패');
  }

  static async get(deviceId: number): Promise<SiteNetworkDevice> {
    const response = await apiClient.get<ApiItemResponse<SiteNetworkDevice>>(
      API_ENDPOINTS.SITE_MANAGEMENT.NETWORK_DEVICES.GET(deviceId),
    );
    return unwrapItem(response, '네트워크 장비 조회 실패');
  }

  static async create(projectId: number, data: CreateSiteNetworkDeviceRequest): Promise<SiteNetworkDevice> {
    const response = await apiClient.post<ApiItemResponse<SiteNetworkDevice>>(
      API_ENDPOINTS.SITE_MANAGEMENT.NETWORK_DEVICES.CREATE(projectId),
      data,
    );
    return unwrapItem(response, '네트워크 장비 생성 실패');
  }

  static async update(deviceId: number, data: UpdateSiteNetworkDeviceRequest): Promise<SiteNetworkDevice> {
    const response = await apiClient.put<ApiItemResponse<SiteNetworkDevice>>(
      API_ENDPOINTS.SITE_MANAGEMENT.NETWORK_DEVICES.UPDATE(deviceId),
      data,
    );
    return unwrapItem(response, '네트워크 장비 수정 실패');
  }

  static async delete(deviceId: number): Promise<void> {
    const response = await apiClient.delete<ApiOkResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.NETWORK_DEVICES.DELETE(deviceId),
    );
    ensureOk(response, '네트워크 장비 삭제 실패');
  }
}
